module.exports = __webpack_public_path__ + "static/hero-placeholder-ses-v2-e752fe05a5525c5cb6474893ea67db75.gif";